import { ChevronDown, ChevronRight } from "lucide-react";
import { cn } from "src/shadcn/lib/utils";

interface SwitcherIconProps {
  expanded: boolean;
  className?: string;
}

export const SwitcherIcon = ({ expanded, className }: SwitcherIconProps) =>
  expanded ? (
    <ChevronDown className={cn("size-4 shrink-0", className)} />
  ) : (
    <ChevronRight className={cn("size-4 shrink-0", className)} />
  );
